module.exports = __webpack_public_path__ + "img/21.problem_stainless_steel.482dc106.svg";